export const removeTags = (initialTags: string[] | undefined, toBeRemoved: string[]) => {
  return (initialTags ?? []).filter((tag) => !toBeRemoved.includes(tag));
};
